export default __webpack_public_path__ + "static/media/ac_ult.6286922c.bmp";